import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import TextFormat from "./../TextFormat";

const TITLE_OUTLINE = '0.15rem 0.15rem 0.15rem black';
const TEXT_OPACITY = 0.65;
const DETAIL_SATURATION_PCT = 22;

const DetailTitle = styled.div`
    font-size: 1.618rem;
    font-family: Courier;
    font-weight: bold;
    color: white;
    text-shadow: ${TITLE_OUTLINE};
    padding: 0.25rem 1rem 0.75rem 2.5rem
    letter-spacing: 0.75rem;
`;

const DetailSummary = styled.div`
    color: rgba(0,0,0,${TEXT_OPACITY});
    padding: 0 2.5rem 0.5rem;
    font-size: 1.125rem;
`;

const DetailHeader = styled.div`
    font-size: 1rem;
    color: white;
    padding: 0 0.5rem;
    margin-bottom: 0.5rem;
    height: 1.5rem;
    vertical-align: bottom;
    box-shadow: 0.25rem 0.25rem 0.5rem rgba(0,0,0,0.25);
`;

const HeaderLede = styled.div`
    display: inline-block;
    float: right;
    font-style: italic;
    font-size: 0.75rem;
    line-height: 1.67rem;
    margin: 0 0.25rem;
    opacity: 0.65;
`;

const HeaderSubject = styled.div`
    display: inline-block;
    float: right;
    font-size: 1rem;
    opacity: 0.8;
    cursor: pointer;
    line-height: 1.5rem;
    text-shadow: 0.125rem 0.125rem 0.25rem rgba(0,0,0,50%);
    &:hover {
        opacity: 1.0;
    }
`;

const DetailFooter = styled.div`
    font-size: 1rem;
    padding: 0.25rem;
    text-align: center;
    letter-spacing: 1.25vw;
    font-weight: normal;
    color: white;
    margin-top: 1rem;
    box-shadow: 0 0 1.5rem rgba(0,0,0,0.15);
`;

const DefinitionText = styled.div`
    font-size: 1.125rem;
    font-style: italic;
    margin-top: 0.25rem;
`;

const ItemTitle = styled.span`
    font-size: 0.65rem;
    text-transform: uppercase;
    color: white;
    padding: 0.05rem 0.25rem;
    border-radius: 0.25rem;    
`;

export class ReferenceDetail extends Component {

    static propTypes = {
        reference_title: PropTypes.string.isRequired,
        reference_data: PropTypes.object.isRequired
    }

    state = {};

    componentDidMount() {
    }

    render_header = () => {
        const {reference_data} = this.props;

        const lede_text = "more in reference:"
        const lede = <HeaderLede>{lede_text}</HeaderLede>
        const subject = <HeaderSubject>
            <TextFormat text={reference_data.subject}/>
        </HeaderSubject>

        const header_style = {backgroundColor: `hsl(${reference_data.hue}, ${DETAIL_SATURATION_PCT}%, 55%)`}
        return <DetailHeader style={header_style}>
            {subject}{lede}
        </DetailHeader>
    }

    render_footer = () => {
        const {reference_data} = this.props;
        const upper_color = `hsla(${reference_data.hue}, ${DETAIL_SATURATION_PCT}%, 95%, 60%)`;
        const lower_color = `hsla(${reference_data.hue}, ${DETAIL_SATURATION_PCT}%, 85%, 40%)`;
        const footer_style = {
            background: `linear-gradient(to bottom right, ${upper_color}, ${lower_color})`,
            textShadow: `0.125rem 0.125rem 0.25rem hsl(${reference_data.hue}, 15%, 15%)`
        }
        const footer_text = "the book of light";
        return <DetailFooter style={footer_style}>
            {footer_text}
        </DetailFooter>
    }

    section_title = (title_text, attribute_name) => {
        const {reference_data} = this.props;
        if (!reference_data.detail.items) {
            return '';
        }
        if (!reference_data.detail.items[attribute_name]) {
            return '';
        }
        const upper_color = `hsl(${reference_data.hue}, ${DETAIL_SATURATION_PCT}%, 30%)`;
        const lower_color = `hsl(${reference_data.hue}, ${DETAIL_SATURATION_PCT}%, 60%)`;
        const title_style = {
            background: `linear-gradient(to bottom right, ${upper_color}, ${lower_color})`,
            border: `0.1rem solid hsl(${reference_data.hue}, ${DETAIL_SATURATION_PCT}%, 10%)`
        }
        return <ItemTitle style={title_style}>{title_text}</ItemTitle>;
    }

    render_definition = () => {
        const {reference_data} = this.props;
        const section_title = this.section_title("definition", "definition");
        const definition_text = section_title ?
            reference_data.detail.items.definition.value : reference_data.text;
        return <DetailSummary>
            {section_title}
            <DefinitionText>
                <TextFormat text={definition_text}/>
            </DefinitionText>
        </DetailSummary>
    }

    render_aka = () => {
        const {reference_data} = this.props;
        const section_title = this.section_title("also called", "aka");
        if (!section_title) {
            return '';
        }
        return <DetailSummary>
            {section_title}
            <DefinitionText>
                <TextFormat text={reference_data.detail.items.aka.value}/>
            </DefinitionText>
        </DetailSummary>
    }

    render() {
        const {reference_title} = this.props;

        const title = <DetailTitle><TextFormat text={reference_title}/></DetailTitle>
        return <div>
            {this.render_header()}
            {title}
            {this.render_definition()}
            {this.render_aka()}
            {this.render_footer()}
        </div>
    }
}

export default ReferenceDetail;
